import { WebData } from "@lvt/web-data";
import { DateTime } from "luxon";


export interface ArchiveCabinetInfo {
    id: number;
    clientId: number;
    clientName: string | null;
    locationName: string | null;
    liveUnitName: string | null;
    city: string | null;
    state: string | null;
    accessArchives: boolean;
    showClientName: boolean;
}

export const isArchiveCabinetInfo = (value: ArchiveCabinetInfo | Error): value is ArchiveCabinetInfo => {
    return value.hasOwnProperty("id");
};

export interface ArchiveImagesNavMeta {
    liveUnitId: number;
    clientId: number;
    name: string;
    recordingStart: string | null; //needs to be UTC?
    archiveImagesStart: string | null; //needs to be UTC?
    timezone: string;
    cameraIds: Array<number>;
}

export const NullArchiveImagesNavMeta: ArchiveImagesNavMeta = {
    liveUnitId: 0,
    clientId: 0,
    name: "Null Metadata",
    recordingStart: null,
    archiveImagesStart: null,
    timezone: DateTime.now().toUTC().zoneName,
    cameraIds: [],
};

export const isArchiveImagesNavMeta = (value: ArchiveImagesNavMeta | Error): value is ArchiveImagesNavMeta => {
    return value.hasOwnProperty("liveUnitId");
};

export const isCameraOrCabinetMetadata = (
    value: CameraOrCabinetMetadata[] | Error,
): value is CameraOrCabinetMetadata[] => {
    return Array.isArray(value) && value.every((data) => data.hasOwnProperty("record"));
};

// camera_metadata()
// returns Array<CameraMetadata>
export interface CameraOrCabinetMetadata {
    record: Camera | Cabinet;
    archivedVideos: Array<ArchivedVideo>;
    presets: Array<Preset>;
}

export interface CameraOrCabinetMetadataResponse {
    record: {
        camera?: Camera;
        cabinet?: Cabinet;
    };
    archivedVideos: Array<ArchivedVideo>;
    presets: Array<Preset>;
}

export interface ArchivedVideo {
    id: number;
    cameraId: number | null;
    archiveCabinetId: number | null;
    title: string | null;
    url: string | null;
    bytes: number | null;
    timestampRecorded: string | null;
    timestampRequested: string | null;
    requestedDurationMinutes: number | null;
}

export interface Camera {
    id: number;
    name: string;
    notRecordingReason: string | null;
    canRequestVideo: boolean;
    clientId: number | null;
}

export const isCamera = (value: Camera | Cabinet): value is Camera => {
    return value.hasOwnProperty("canRequestVideo");
};

export interface Cabinet {
    id: number;
    name: string;
    notRecordingReason: string | null;
    clientId: number | null;
}

export interface Preset {
    id: number;
    cameraId: number | null;
    archiveCabinetId: number | null;
    name: string | null;
    default: boolean;
}

// export enum NotRecordingReason {
//     ArchiveCabinet = "Archive Cabinet",
//     CameraNeverActivated = "Camera Never Activated",
//     StopRecording = "Stop Recording",
//     RecordVideoTypeNotRecording = "Record Video Type: Not Recording",
//     RecordVideoTypeInternalSD = "Record Video Type: InternalSD",
// }

// get_images()
export interface ArchiveImage {
    datetimeRecorded: string; //needs to be UTC?
    imageUrl: string;
    thumbUrl: string | null;
    presetId: number;
}

// Record<bucket unix timestamp, Record<preset id, images>>
export type BucketImages = Record<number, PresetsToImages>;
// Record<preset id, images>
export type PresetsToImages = Record<number, WebData<ArchiveImage[]>>;
// Record<bucket unix timestamp, images>
export type PresetImages = Record<number, WebData<ArchiveImage[]>>;

// submit_feedback()
// returns a string

// get_archive_cabinets()
// export interface ArchiveCabinet {
//     id: number,
//     clientId: number,
//     groupId: number,
//     groupName: string,
//     unitName: string,
//     cameraName: string,
//     gpsLat: number | null,
//     gpsLng: number | null,
// }

// request_video()
// returns an i64

export interface ThumbnailResponse {
    requestedTime: string; //needs to be UTC?
    thumbnail: ArchiveImage | null;
}
